let headerScrollTrigger
let desktopMenuTimeline = null;

let tArray = [];
let sArray = [];
let currentTimeout = null; // Variable para almacenar el timeout actual

function getScrollableMain() {
    return document.querySelector('main.lenis') || document.querySelector('main');
}

function setScrollableMainOverflow(value = '') {
    const main = getScrollableMain();

    if (!main) return;

    main.style.overflow = value;
}

export function closeDesktopMenu() {
    if (currentTimeout) {
        clearTimeout(currentTimeout);
        currentTimeout = null;
    }

    setScrollableMainOverflow('');

    if (desktopMenuTimeline && desktopMenuTimeline.progress() > 0) {
        desktopMenuTimeline.reverse();
    }

    tArray.forEach(timeline => {
        if (timeline.progress() > 0) {
            timeline.reverse();
        }
    });
}

document.addEventListener('cmpth:close-desktop-menu', closeDesktopMenu);

export function initHeader(d) {
    const header = document.querySelector(".header");
    if(document.querySelector('body').classList.contains('home')){
        gsap.to(header, {
            scrollTrigger: {
                start: 'top top',
                end: '+=200px',
                scrub: true,
                onEnter: () => {
                    header.classList.remove("sticky", "active");
                },
                onLeave: () => {
                    header.classList.add("sticky", "active");
                },
                onEnterBack: () => {
                    header.classList.remove("sticky", "active");
                },
            },
        });
    }else{
        header.classList.add("sticky", "active");
    }

    ScrollTrigger.create({
        trigger: header,
        endTrigger: d.querySelector("footer"),
        start: 'top -550',
        end: 'top 110',
        onUpdate: self => {
            let { direction } = self;
            if (direction == -1) {
                header.classList.remove("hide");
                if(!document.querySelector('.section-tabs') || !document.querySelector('.section-tabs').classList.contains('pinned')) return
                document.querySelector('.section-tabs').classList.remove('hide');
            } else if (direction == 1) {
                header.classList.add("hide");
                


                if(!document.querySelector('.section-tabs') || !document.querySelector('.section-tabs').classList.contains('pinned')) return
                document.querySelector('.section-tabs').classList.add('hide');
            }
        }
    });
}

export function initDesktopMenu(){
    const header = document.querySelector(".header");
    const headerElement = document.querySelector('header.header');
    const menuInteraction = document.querySelector('.menu-interaction');
    const viewport = document.querySelector('#viewport');
    const headerDummy = document.querySelector('.dummy');

    if (!header || !headerElement || !menuInteraction || !viewport || !headerDummy) return;
    if (document.querySelector('.submenus-wrapper-desktop')) return;

    tArray = [];
    sArray = [];

    const submenusWrapper = document.createElement("div");
    submenusWrapper.classList.add("submenus-wrapper-desktop");
    headerElement.after(submenusWrapper);
	
    
    var accordeon_clicks = document.querySelectorAll(
		'.desktop-menu > div > ul > li'
	);
	if (!accordeon_clicks) return;
	desktopMenuTimeline = gsap.timeline({
        onStart: () => {
            header.classList.add("sticky");
            setScrollableMainOverflow('hidden');
        },
        onReverseComplete: () => {
            setScrollableMainOverflow('');
            if(header.classList.contains("active") && !document.querySelector('body').classList.contains('home')) return
			header.classList.remove("sticky");
            
        }
    });

	desktopMenuTimeline.to(submenusWrapper, {
		height: "90vh",
		duration: 0.6,
		ease: 'Power2.easeInOut',
	});
	desktopMenuTimeline.progress(0).pause();

	accordeon_clicks.forEach(function (accordeon_click, i) {

        const submenu = accordeon_click.querySelector(".sub-menu");
        if (submenu) {
            const submenuWrapper = document.createElement("div");
            submenuWrapper.classList.add("submenu-wrapper");
            const submenuWrapperContent = document.createElement("div");
            submenuWrapperContent.classList.add("submenu-wrapper-content");
            const submenuWrapperContentWrapper = document.createElement("div");
            submenuWrapperContentWrapper.classList.add("submenu-wrapper-content-wrapper");
            const text = accordeon_click.querySelector('a').textContent;
            const title = document.createElement("h3");
            title.textContent = text;
            const id = accordeon_click.getAttribute("id");
            submenu.classList.add(id);
            submenuWrapperContentWrapper.appendChild(title);
            submenuWrapperContentWrapper.appendChild(submenu);
            submenuWrapperContent.appendChild(submenuWrapperContentWrapper);
           
            submenuWrapper.appendChild(submenuWrapperContent);

            const imageDisplay = document.createElement("div");
            imageDisplay.classList.add("submenu-image-display");
            submenuWrapper.appendChild(imageDisplay); 
            submenusWrapper.appendChild(submenuWrapper);
            gsap.set(submenuWrapper, {
                autoAlpha: 0,
                pointerEvents: 'none',
                zIndex: 0,
            });

            let currentVisibleImageIndex = -1; // -1 significa ninguna visible inicialmente

            // Animar descripción y mostrar imagen en hover
            const submenuLinks = submenu.querySelectorAll("li a");
            
            submenuLinks.forEach((link, index) => {
                // Añadir imagen del link al imageDisplay
                const linkImageSource = link.querySelector("img.image-menu");
                
                if (linkImageSource) {
                    const imageClone = linkImageSource.cloneNode(true);
                    imageClone.dataset.linkIndex = index; 
                    gsap.set(imageClone, { 
                        autoAlpha: 0, 
                        position: 'absolute', 
                        top: 0, 
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover' 
                    }); 
                    imageDisplay.appendChild(imageClone);

                    // Si es la primera imagen, marcarla como visible inicialmente
                    if (currentVisibleImageIndex === -1) {
                        gsap.set(imageClone, { autoAlpha: 1 });
                        currentVisibleImageIndex = index;
                    }
                }

                // Manejar descripción
                const description = link.querySelector(".description-wrapper");
                if (description) {
                    gsap.set(description, { height: 0, overflow: 'hidden' }); 
                }

                // Listeners para hover en el link
                link.addEventListener('mouseenter', () => {
                    // Animar descripción
                    if (description) {
                        gsap.to(description, { height: 'auto', duration: 0.6, ease: 'power1.inOut' });
                    }

                    // --- Crossfade Logic ---
                    if (index !== currentVisibleImageIndex) {
                        const previousImage = imageDisplay.querySelector(`img[data-link-index="${currentVisibleImageIndex}"]`);
                        const targetImage = imageDisplay.querySelector(`img[data-link-index="${index}"]`);
                        
                        // Ocultar la anterior (si existe y es diferente de la nueva)
                        if (previousImage) {
                            gsap.to(previousImage, { autoAlpha: 0, duration: 0.6, ease: 'power1.inOut' });
                        }
                        
                        // Mostrar la nueva (si existe)
                        if (targetImage) {
                            gsap.to(targetImage, { autoAlpha: 1, duration: 0.6, ease: 'power1.inOut' }); 
                        }
                        
                        currentVisibleImageIndex = index; // Actualizar índice visible
                    }
                    // --- End Crossfade Logic ---
                });

                link.addEventListener('mouseleave', () => {
                    // Animar descripción
                    if (description) {
                        gsap.to(description, { height: 0, duration: 0.6, ease: 'power1.inOut' });
                    }
                    // La imagen permanece visible al salir, no necesitamos cambios aquí
                });
            });

            // No necesitamos mostrar la primera imagen aquí, ya se hizo en el bucle

        }

			if (
				accordeon_click
					.classList.contains('menu-item-has-children')
			) {
				if (!submenu) return;
				let timeline = createTimeline(submenu);
				accordeon_click.addEventListener('mouseenter', () => {
				// Cancelar timeout anterior si existe
				if (currentTimeout) {
					clearTimeout(currentTimeout);
					currentTimeout = null;
				}
				
				// Crear nuevo timeout con delay de 1 segundo
				currentTimeout = setTimeout(() => {
					desktopMenuTimeline.play();
					tArray.forEach(OTimeline => {
						if (OTimeline == timeline) return;
						OTimeline.reverse();
					});
					//timeline.progress(0);
					timeline.play();
					currentTimeout = null; // Limpiar referencia
				}, 0);
			});
		} else {

            accordeon_click.addEventListener('mouseenter', () => {
                if (currentTimeout) {
					clearTimeout(currentTimeout);
					currentTimeout = null;
				}else{
                    if (desktopMenuTimeline.progress() == 1) {
                        desktopMenuTimeline.reverse();
                        tArray.forEach(OTimeline => {
                            OTimeline.reverse();
                        });
                    }
                }
				
			});
		}
	});

	menuInteraction.addEventListener('mouseleave', () => {
            if (currentTimeout) {
                clearTimeout(currentTimeout);
                currentTimeout = null;
            }else{
                if (desktopMenuTimeline.progress() == 1) {
                    desktopMenuTimeline.reverse();
                    tArray.forEach(timeline => {
                        timeline.reverse();
                    });
                }
            }
		});
	viewport.addEventListener('mouseenter', () => {
        if (currentTimeout) {
            clearTimeout(currentTimeout);
            currentTimeout = null;
        }else{
            if (desktopMenuTimeline.progress() == 1) {
                desktopMenuTimeline.reverse();
                tArray.forEach(timeline => {
                    timeline.reverse();
                });
            }
        }
	});
    headerDummy.addEventListener('mouseenter', () => {
        if (currentTimeout) {
            clearTimeout(currentTimeout);
            currentTimeout = null;
        }else{
            if (desktopMenuTimeline.progress() == 1) {
                desktopMenuTimeline.reverse();
                tArray.forEach(timeline => {
                    timeline.reverse();
                });
            }
        }
	});

		


}


function createTimeline(el) {
	if (!el) return null;

	const wrapper = el.closest('.submenu-wrapper');

	if (!wrapper) return null;

	let t = gsap.timeline();

	t.eventCallback('onStart', () => {
		gsap.set(wrapper, {
			pointerEvents: 'auto',
			zIndex: 10,
		});
	});

	t.eventCallback('onReverseComplete', () => {
		gsap.set(wrapper, {
			pointerEvents: 'none',
			zIndex: 0,
		});
	});

	t.to(wrapper, {
		delay: 0.3,
		stagger: 0.02,
		autoAlpha: 1,
		duration: 0.3,
		zIndex:10,
		ease: 'Power2.easeInOut',
		
	});
	

	t.pause();

	tArray.push(t);

	return t;
}
